export default __webpack_public_path__ + "static/media/nflStaff16.d55f56e2.jpg";